/** XOR key — payload is char codes XOR'd with this value (not plain text in HTML). */
const KEY = 0x5a;

export function encodeEmailPayload(email: string): number[] {
  return [...email.trim()].map((char) => char.charCodeAt(0) ^ KEY);
}

export function decodeEmailPayload(payload: number[]): string {
  return payload.map((code) => String.fromCharCode(code ^ KEY)).join("");
}
